<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @export="exportFile"
      @download="downloadFile"
      @openEditPage="openEditPage"
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        :checked-count="checkedCount"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
        @exportFile="batchExportFile"
        @sendWarehouse="batchSendWarehouse"
        @clearCheckboxRow="clearCheckboxRow"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: {
          amzFtyNoticeOutCode: chooseTemplateOptions.amzFtyNoticeOutCode,
        },
      }"
      @export-success="clearCheckboxRow"
    />

    <DownloadDoc
      :visible.sync="downloadDocOptions.visible"
      :amzFtyNoticeOutCode="downloadDocOptions.amzFtyNoticeOutCode"
    />
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header'
import chooseTemplate from '@/views/ecom/components/choose-template'
import DownloadDoc from '../download-doc'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, chooseTemplate, DownloadDoc },
  data() {
    return {
      checkedRow: [],
      usePage: true,
      chooseTemplateOptions: {
        visible: false,
        amzFtyNoticeOutCode: '',
        templateGroup: '',
      },
      downloadDocOptions: {
        visible: false,
        amzFtyNoticeOutCode: '',
      },
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzFtyNoticeOutListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
          // this.checkedRow = []
        })
        .catch(() => {
          this.loading = false
        })
    },
    batchExportFile(templateGroup) {
      const amzFtyNoticeOutCode = this.checkedRow
        .map((e) => e.amzFtyNoticeOutCode)
        .join(',')
      console.log(amzFtyNoticeOutCode)
      this.chooseTemplateOptions = {
        visible: true,
        amzFtyNoticeOutCode,
        templateGroup,
      }
    },
    async batchSendWarehouse() {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_sendWarehouse') || '是否要进行通知送仓操作？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const amzFtyNoticeOutCodeList = this.checkedRow.map(
        (row) => row.amzFtyNoticeOutCode
      )
      const res = await this.$api
        .ecomAmzFtyNoticeOutSendWarehouseApi({
          amzFtyNoticeOutCodeList: amzFtyNoticeOutCodeList,
        })
        .catch(() => null)
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error('通知失败！')
        return
      }
      this.$refs.header.query()
      this.clearCheckboxRow()
      this.$message({ showClose: true, message: '通知成功！', type: 'success' })
    },
    clearCheckboxRow() {
      this.checkedRow = []
      this.$refs.main.clearCheckboxRow()
    },
    exportFile({ amzFtyNoticeOutCode }, { templateGroup }) {
      this.chooseTemplateOptions = {
        visible: true,
        amzFtyNoticeOutCode,
        templateGroup,
      }
    },
    downloadFile({ amzFtyNoticeOutCode }) {
      if (!amzFtyNoticeOutCode) return
      this.downloadDocOptions = {
        visible: true,
        amzFtyNoticeOutCode,
      }
    },
    openEditPage({ pageType, data = {} }) {
      let params = { pageType }
      let query = {}
      const { amzFtyNoticeOutCode = '', amzFtyNoticeOutNo = '' } = data
      if (amzFtyNoticeOutNo) query = { ...query, amzFtyNoticeOutNo }
      if (amzFtyNoticeOutCode) params = { ...params, amzFtyNoticeOutCode }

      if (pageType === 'generate') {
        this.$api
          .ecomAmzFtyNoticeOutCheckNoticeInApi({ amzFtyNoticeOutCode })
          .then((res) => {
            const { status, msg } = res
            if (status == 200) {
              params.pageType = 'add'
              params.amzFtyNoticeInCode = amzFtyNoticeOutCode
              this.$router.push({
                name: 'ecom-awsBiz-ftyInvInNotice-detail',
                params,
                query,
              })
            }
            if (status == 203) {
              this.$confirm(
                msg,
                this.$l('INDEX.tips_question_title') || '提示信息',
                {
                  confirmButtonText:
                    this.$l('INDEX.product_dialog_btn_confirm') || '确定',
                  type: 'warning',
                  showCancelButton: false,
                  closeOnClickModal: false,
                  closeOnPressEscape: false,
                }
              ).then(() => {})
            }
          })
        return
      }

      this.$router.push({
        name: 'ecom-awsBiz-ftyInvOutNotice-detail',
        params,
        query,
      })
    },
  },
}
</script>
